import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const EASE = [0.16, 1, 0.3, 1];

const FAQS = [
  {
    q: "What is the SANTELQ Hub?",
    a: "It's a machine that checks your health in about a minute. You step in, it does the checkup, and you walk out with your results.",
  },
  {
    q: "Do I need an appointment?",
    a: "No. Just walk up and use it — like an ATM, but for your health.",
  },
  {
    q: "Is my information safe?",
    a: "Yes. Everything is locked up tight with hospital-grade security (HIPAA compliant and AES-256 encryption), and only your care team can see your results.",
  },
  {
    q: "Who is it for?",
    a: "Clinics that want to see more patients with less waiting, and workplaces that want healthy, happy teams on-site.",
  },
  {
    q: "How much does it cost to pre-order?",
    a: "You can reserve a Hub today with a $300 deposit. It's fully refundable if you change your mind.",
  },
];

export const Faq = () => (
  <section className="py-24 lg:py-32 px-6 sm:px-12 max-w-2xl mx-auto" data-testid="faq-section">
    <motion.h2
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE }}
      className="font-display font-semibold tracking-tight text-center text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15]"
    >
      Questions? Answers.
    </motion.h2>
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 1, ease: EASE, delay: 0.1 }}
      className="mt-10"
    >
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-black/8">
            <AccordionTrigger
              data-testid={`faq-question-${i}`}
              className="font-display font-medium text-left text-[#3A3A3C] text-base tracking-tight hover:no-underline py-5"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent
              className="text-[#474747] text-sm leading-relaxed pb-5"
              data-testid={`faq-answer-${i}`}
            >
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
);
